(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/pages/frejaeid/use-frejaeid-poll-status.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/pages/frejaeid/use-frejaeid-poll-status.js');

'use strict';

const {
  logger
} = svs.playerLoginReact;
const FrejaeIdService = svs.playerLoginReact.frejaeid.FrejaeIdService;
const {
  frejaeIdProgressStatus,
  frejaeIdErrorCodes,
  route
} = svs.playerLoginReact.constants;
const {
  useFrejaeIdErrorHandling
} = svs.playerLoginReact.frejaeid;
const {
  useHistory
} = ReactRouterDOM;
const isBankId = false;
const {
  storeCustomerType,
  saveRefForGUITest
} = svs.playerLoginReact.sharedComponents.sharedUtils;
const {
  handleShowFrejaEidError
} = svs.playerLoginReact.sharedComponents.Dialogs;
const {
  frejaeIdAuthRefChangeAction
} = svs.playerLoginReact.store.playerloginreactactions;
const {
  useCheckPlayerAfterSession
} = svs.playerLoginReact.sharedComponents;
const {
  useUrlHelper
} = svs.playerLoginReact.sharedComponents;
const TIME_TO_FREJA_REFRESH_QR = 240000; 

const useFrejaeIdPollStatus = (isLogin, authRef) => {
  const isQrCode = true;
  logger.debug('*** init useFrejaeIdPollStatus');
  const history = useHistory();
  const dispatch = ReactRedux.useDispatch();
  const {
    handleShowFrejaeIdStatusCodeError,
    handleShowFrejaeIdErrorCode
  } = useFrejaeIdErrorHandling();
  const isStandardMobile = ReactRedux.useSelector(state => state.playerloginreact.isStandardMobile);
  const isReturnNewCustomer = ReactRedux.useSelector(state => state.playerloginreact.isReturnNewCustomer);
  const returnUrl = ReactRedux.useSelector(state => state.playerloginreact.returnUrl);
  const authRefTokenRef = React.useRef('');
  const qrCodeRetries = React.useRef(2); 
  const isLastQrRetry = qrCodeRetries.current <= 1;
  const pollStartRef = React.useRef();
  const [appUrl, setAppUrl] = React.useState('');
  const [qrCode, setQrCode] = React.useState('');
  const networkRetries = React.useRef(2);
  const isUnmountingRef = React.useRef(false);
  const timeOutRef = React.useRef(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isPolling, setIsPolling] = React.useState(false);
  const [backendStatus, setBackendStatus] = React.useState(frejaeIdProgressStatus.BEFORE_POLL);
  const [dataError, setDataError] = React.useState(false);
  const checkPlayerAfterSessionAsync = useCheckPlayerAfterSession();
  const {
    navigateToReturnUrl,
    getFrejaeIdAppUrl,
    getFrejaeIdQrData
  } = useUrlHelper();
  const initFrejaeIdcodeAsync = React.useCallback(async () => {
    try {
      const authRefLocal = await FrejaeIdService.getFrejaeIdAuthRefTokenAsync(isLogin);
      if (!isUnmountingRef.current) {
        authRefTokenRef.current = authRefLocal;
        pollStartRef.current = Date.now();
      }

      saveRefForGUITest(authRefLocal);
      logger.debug('**** Got authRef token: ', authRefLocal);
      const appUrlLocal = getFrejaeIdAppUrl(authRefLocal);
      logger.debug('**** Got appUrl: ', appUrlLocal);
      const qrCode = getFrejaeIdQrData(authRefLocal);
      logger.debug('**** Got qrCode: ', qrCode);
      !isUnmountingRef.current && setAppUrl(appUrlLocal);
      !isUnmountingRef.current && setQrCode(qrCode);
      return {};
    } catch (error) {
      logger.warn('Error, could not get authRef token. Error was ', error);
      handleShowFrejaEidError(history);
      return {
        error
      };
    }
  }, [isLogin]);
  const checkFrejaeIdLoginStatusAsync = async () => {
    if (authRefTokenRef.current) {
      try {
        const response = await FrejaeIdService.pollCustomerLoginAsync(authRefTokenRef.current);
        return response;
      } catch (error) {
        logger.info('Error, could not get checkFrejaeIdLoginStatus. Error was ', error);
        return {
          status: -1,
          error
        };
      }
    } else {
      return {
        status: 0
      };
    }
  };
  const handleNewUserOnLogin = () => {
    var _svs;
    logger.debug('*** new user on login, redirect to registrate');
    if (!((_svs = svs) !== null && _svs !== void 0 && (_svs = _svs.accountservices) !== null && _svs !== void 0 && (_svs = _svs.check_iam) !== null && _svs !== void 0 && _svs.isInSweden)) {
      var _svs2;
      logger.info("foreignLogin=\"true\" action=\"Customer Registration\" label=\"started_new_customer_from_frejaeid\" countryCode=\"".concat((_svs2 = svs) === null || _svs2 === void 0 || (_svs2 = _svs2.accountservices) === null || _svs2 === void 0 || (_svs2 = _svs2.check_iam) === null || _svs2 === void 0 ? void 0 : _svs2.countryCode, "\""));
    }
    svs.components.analytics.trackEvent({
      category: 'Users',
      action: 'Customer Registration',
      opt_label: 'started_new_customer_from_frejaeid'
    }, () => {
      const custRegDialogTitle = 'Skapa spelkonto';
      const custRegDialogMessage = 'För att spela hos AB Svenska Spel behöver du skapa ett spelkonto.';
      const dialog = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        icon: 'help-2',
        type: svs.ui.dialog.type.INFO,
        title: custRegDialogTitle,
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: custRegDialogMessage
        }],
        actions: [{
          title: 'Okej',
          callback: () => {
            history.push(route.REGISTRATE_FREJAEID_ROUTE);
            dialog.close();
          }
        }]
      });
      svs.ui.dialog.api.add(dialog);
    }, void 0);
  };
  const handleErrorPoll = error => {
    logger.debug('FrejaeIdQrCode: checkStatusChange got progressStatus -1 error: ', error);
    if (error.code === 16) {
      dispatch(frejaeIdAuthRefChangeAction(''));
      handleNewUserOnLogin();
    } else if (networkRetries.current > 0) {
      logger.info("Received network error: ".concat(error.code, ", retrying"));
      networkRetries.current = networkRetries.current - 1;
      timeOutRef.current = startTimeOutPoll();
    } else {
      var _svs3;
      logger.info("checkStatusChange got error code: ".concat(error.code));
      if (!((_svs3 = svs) !== null && _svs3 !== void 0 && (_svs3 = _svs3.accountservices) !== null && _svs3 !== void 0 && (_svs3 = _svs3.check_iam) !== null && _svs3 !== void 0 && _svs3.isInSweden)) {
        var _svs4;
        logger.info("foreignLogin=\"true\" action=\"Login Failure\" label=\"frejaeid\" countryCode=\"".concat((_svs4 = svs) === null || _svs4 === void 0 || (_svs4 = _svs4.accountservices) === null || _svs4 === void 0 || (_svs4 = _svs4.check_iam) === null || _svs4 === void 0 ? void 0 : _svs4.countryCode, "\""));
      }
      svs.components.analytics.trackEvent({
        category: 'Users',
        action: 'Login Failure',
        opt_label: 'frejaeid',
        opt_value: error.code || 665
      });
      dispatch(frejaeIdAuthRefChangeAction(''));
      if (isStandardMobile) {
        handleShowFrejaeIdErrorCode(error, isLogin, false);
        if (isLogin) {
          history.push(route.LOGIN_FREJAEID_ROUTE);
        } else {
          history.push(route.REGISTRATE_FREJAEID_ROUTE);
        }
      } else {
        handleShowFrejaeIdErrorCode(error, isLogin, true);
      }
    }
  };
  const handleClientTimeout = async (response, status) => {
    if (qrCodeRetries.current > 0) {
      logger.debug("Login with Freja eID timed out, but we make a retry to prolong timeout for customer, status: ".concat(response.status));
      qrCodeRetries.current--;
      await initFrejaeIdcodeAsync();
      timeOutRef.current = startTimeOutPoll();
    } else {
      logger.debug("Login with Freja eID timed out, status: ".concat(status));
      authRefTokenRef.current = '';
      setQrCode('');
      setBackendStatus(frejaeIdProgressStatus.CLIENT_TIMEOUT);
    }
  };
  const handleRetailCustomer = (response, progressStatus) => {
    var _svs5;
    logger.debug('checkStatusChange run: progressStatus === 20, 21 or 22');
    response.deviceId = undefined;
    response.requestId = undefined;
    response.requestInfo = undefined;
    response.ssn = undefined;
    response.eid = 'frejaeid';
    response.progressStatus = progressStatus;
    if (isReturnNewCustomer) {
      svs.components.Storage.browser.remove('returnUrl', 'player-login', () => {});
      response.returnUrl = returnUrl; 
    }
    const newCustomerEvent = {
      category: 'Users',
      action: 'Customer Registration'
    };
    let customerType = '';
    switch (progressStatus) {
      case frejaeIdProgressStatus.REACTIVATED_CUSTOMER:
        newCustomerEvent.opt_label = 'started_reactivated_customer_from_frejaeid';
        customerType = 'reactivated';
        break;
      case frejaeIdProgressStatus.NEW_CUSTOMER:
        newCustomerEvent.opt_label = 'started_new_customer_from_frejaeid';
        customerType = 'new';
        break;
      case frejaeIdProgressStatus.RETAIL_CUSTOMER:
        newCustomerEvent.opt_label = 'started_retail_customer_from_frejaeid';
        customerType = 'retail';
        break;
      default:
        logger.warn('Unexpected status in handleRetailCustomer:', progressStatus);
    }
    if (!((_svs5 = svs) !== null && _svs5 !== void 0 && (_svs5 = _svs5.accountservices) !== null && _svs5 !== void 0 && (_svs5 = _svs5.check_iam) !== null && _svs5 !== void 0 && _svs5.isInSweden)) {
      var _svs6;
      logger.info("foreignLogin=\"true\" action=\"".concat(newCustomerEvent.action, "\" label=\"").concat(newCustomerEvent.opt_label, "\" countryCode=\"").concat((_svs6 = svs) === null || _svs6 === void 0 || (_svs6 = _svs6.accountservices) === null || _svs6 === void 0 || (_svs6 = _svs6.check_iam) === null || _svs6 === void 0 ? void 0 : _svs6.countryCode, "\""));
    }
    svs.components.analytics.trackEvent(newCustomerEvent, () => {
      storeCustomerType(customerType, () => {
        svs.utils.form.postToUrl("".concat(svs.core.urlMapping.get('customerRegistrationCompletion')), response, 'POST');
      });
    });
  };
  const startTimeOutPoll = () => setTimeout(() => {
    const pollWithHandling = async () => {
      try {
        if (document.visibilityState === 'visible') {
          await pollContinuousBackend();
        } else {
          startTimeOutPoll();
        }
      } catch (error) {
        logger.info('Error, in checkFrejaeIdLoginStatusChangeAsync-setTimeout. Error was ', error);
      }
    };
    pollWithHandling();
  }, 1000);
  const pollContinuousBackend = React.useCallback(async () => {
    if (isUnmountingRef.current) {
      logger.debug("*** pollContinuousBackend - isUnmountingRef: ".concat(isUnmountingRef.current));
    } else {
      logger.debug("*** pollContinuousBackend - authRef: ".concat(authRefTokenRef.current));
      const response = await checkFrejaeIdLoginStatusAsync();
      logger.debug('*** pollContinuousBackend - response', response);
      const {
        status,
        session,
        error
      } = response;
      if (session) {
        setBackendStatus(frejaeIdProgressStatus.ONLINE_CUSTOMER);
        await checkPlayerAfterSessionAsync(isBankId, response, isQrCode);
        return;
      }
      setBackendStatus(status);
      logger.debug('*** progressStatus: ', status);
      if (status < 3 && status > 0 && !session && !isUnmountingRef.current) {
        if (Date.now() > pollStartRef.current + TIME_TO_FREJA_REFRESH_QR) {
          logger.debug('polled for 2 minutes. Get new authRef');
          const status = 'cancelled after 2 minutes in client';
          handleClientTimeout({
            status
          }, status);
          return;
        }
        timeOutRef.current = startTimeOutPoll();
      } else {
        switch (status) {
          case frejaeIdProgressStatus.ONLINE_CUSTOMER:
            logger.debug('checkStatusChange run: progressStatus === 6');
            await checkPlayerAfterSessionAsync(isBankId, response, isQrCode);
            break;
          case frejaeIdProgressStatus.NEW_CUSTOMER:
          case frejaeIdProgressStatus.RETAIL_CUSTOMER:
          case frejaeIdProgressStatus.REACTIVATED_CUSTOMER:
            handleRetailCustomer(response, status);
            break;
          case frejaeIdProgressStatus.USER_DECLINED:
            logger.debug("Login aborted by user ".concat(status));
            svs.core.flash('info', {
              title: 'Inloggning avbruten',
              area: svs.ui.dialog.area.POPUP,
              branding: svs.ui.dialog.branding.TUR,
              icon: 'exclamation-sign',
              time: svs.ui.dialog.autoClose.MEDIUM 
            }, () => {
              navigateToReturnUrl();
            });
            break;
          case frejaeIdProgressStatus.SVS_DECLINED:
            logger.debug("Login with Freja eID canceled by RP, status: ".concat(status));
            handleShowFrejaeIdStatusCodeError(status);
            break;
          case frejaeIdProgressStatus.CLIENT_TIMEOUT:
            await handleClientTimeout(response, status);
            break;
          case frejaeIdProgressStatus.DUPLICATED_AUTHTOKEN:
            logger.debug("Login with Freja eID canceled because of more than one authentication transaction for the same user at the same time, status: ".concat(status));
            handleShowFrejaeIdStatusCodeError(status);
            break;
          case frejaeIdProgressStatus.ERROR_POLL:
            if (error.code === frejaeIdErrorCodes.AUTHREF_NOT_FOUND_OR_EXPIRED) {
              await handleClientTimeout(response, status);
            } else {
              handleErrorPoll(error);
            }
            break;
          default:
            logger.warn('invalid status in checkFrejaeIdStatusChange:', status);
            svs.core.flash('info', {
              title: 'Misslyckad inloggning',
              area: svs.ui.dialog.area.POPUP,
              branding: svs.ui.dialog.branding.TUR,
              icon: 'exclamation-sign',
              time: svs.ui.dialog.autoClose.MEDIUM 
            }, () => {
              navigateToReturnUrl();
            });
        }
      }
    }
  }, [history, isLogin, isQrCode, checkPlayerAfterSessionAsync]);
  const cancelBackendPoll = async () => {
    logger.debug('*** function cancelBackendPoll...');
    timeOutRef.current && clearTimeout(timeOutRef.current);
    isUnmountingRef.current = true;
    if (authRefTokenRef.current && authRefTokenRef.current.length > 10) {
      await FrejaeIdService.cancelCustomerLoginAsync(authRefTokenRef.current);
      authRefTokenRef.current = '';
      dispatch(frejaeIdAuthRefChangeAction(''));
    }
  };
  const pollWithHandling = React.useCallback(async () => {
    try {
      await pollContinuousBackend();
    } catch (error) {
      logger.info('Error, in checkFrejaeIdLoginStatusChangeAsync-setTimeout. Error was ', error);
      setDataError(true);
    }
  }, [pollContinuousBackend]);

  const getStartFrejaeId = React.useCallback(async () => {
    logger.debug('*** init useFrejaeIdPollStatus-async useEffect');
    try {
      !isUnmountingRef.current && setIsLoading(true);
      if (!authRef) {
        logger.debug('*** initFrejaeIdcodeAsync');
        const response = await initFrejaeIdcodeAsync();
        if (response.error) {
          return;
        }
      } else {
        authRefTokenRef.current = authRef;
      }
      !isUnmountingRef.current && setIsLoading(false);
      !isUnmountingRef.current && setIsPolling(true);
      logger.debug('*** pollBackend');
      !isUnmountingRef.current && setTimeout(() => {
        pollWithHandling();
      }, 500);
      logger.debug('*** after pollBackend');
      !isUnmountingRef.current && setIsPolling(false);
    } catch (error) {
      !isUnmountingRef.current && setIsLoading(false);
      !isUnmountingRef.current && setIsPolling(false);
      !isUnmountingRef.current && setDataError(true);
      logger.debug("useFrejaeIdPollStatus error:".concat(error));
    }
  }, [authRef, initFrejaeIdcodeAsync, pollWithHandling]);

  React.useEffect(() => {
    logger.debug('*** init useFrejaeIdPollStatus-useEffect');
    getStartFrejaeId();
    return () => {
      logger.debug('*** end polling, unmounting...');
      isUnmountingRef.current = true;
      timeOutRef.current && clearTimeout(timeOutRef.current);
      if (!isStandardMobile) {
        logger.debug('*** end polling, calling cancelBackendPoll...');
        cancelBackendPoll();
      }
    };
  }, []);
  return {
    appUrl,
    qrCode,
    backendStatus,
    isLoading,
    isPolling,
    dataError,
    cancelBackendPoll,
    isLastQrRetry,
    TIME_TO_POLL_TIMEOUT: TIME_TO_FREJA_REFRESH_QR / 1000
  };
};
svs.playerLoginReact.frejaeid.useFrejaeIdPollStatus = useFrejaeIdPollStatus;

 })(window);